function Forms() {
	this.build();
	this.resize();
	barbaCallbacks.push(this);
	resizeCallbacks.push(this);
}

Forms.prototype.build = function () {

	// When clicking a form submit button :
	$('.wpcf7-submit').on('click', function () {
		const $formBlock = $(this).closest('.wpcf7');
		$formBlock.addClass('loading');
	});

	// When the form validation fails or the mail fails to be sent :
	$('.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed', function () {
		const $formBlock = $(this).closest('.wpcf7');
		$formBlock.removeClass('loading');
	});

	// When the mail is successfully sent
	$('.wpcf7').on('wpcf7mailsent', function () {
		const $formBlock = $(this).closest('.wpcf7');
		$formBlock.removeClass('loading');
		$formBlock.addClass('success');
	});

	// Managing form inputs and labels focus and filled states :
	$('.form-field input, .form-field--textarea textarea, .form-field--select select').each(function () {

		$(this).on('focus', function () {
			$(this).closest('.form-field').addClass('active');
		}).on('blur', function () {

			$(this).closest('.form-field').removeClass('active');

			if ($(this).val() === "") {
				$(this).closest('.form-field').removeClass('filled');
			} else {
				$(this).closest('.form-field').addClass('filled');
			}
		});
	});

	$('.form-field--textarea textarea').attr('rows','');

	$('.field-select').on('click', function(){
		$(this).find('select').trigger('focus');
	});

	this.select();

	if( $("#m_pret").length > 0 ) {
		let slider = document.getElementById("m_pret");
		let output = document.getElementById("range_value");
		output.innerHTML = slider.value; // Display the default slider value

		slider.oninput = function () {
			output.innerHTML = this.value;
		};
	}

};

Forms.prototype.resize = function(){
	this.select();
};

Forms.prototype.select = function(){

	if (noTouchEvent) {
		let scrollSelectric = null;
		$('.selectric').selectric({
			theme: "classic"
		}).on('selectric-open', function (event, element, selectric) {
			if (!scrollSelectric) {
				scrollSelectric = Scrollbar.init(
					document.querySelector(".selectric-scroll")
				);
			}
		}).on('selectric-close', function (event, element, selectric) {
			if (scrollSelectric) {
				Scrollbar.destroy(scrollSelectric);
			}
		});
	}

};
